import { useEffect } from "react";
import { applyThemeVariables } from "@/hooks/useThemes";
import { useThemesList } from "@/hooks/useThemes";

/**
 * Loads and applies the user's saved theme on app startup.
 * Reads theme_id from localStorage, finds the matching theme from API,
 * and applies its CSS variables to the document root.
 *
 * If no theme_id is saved (e.g. user used the dark/light toggle which
 * clears it), this component does nothing — globals.css handles it.
 *
 * Mount this once inside the authenticated layout (after login).
 */
export function ThemeLoader() {
  const { data } = useThemesList();
  const themes = data?.themes || [];

  useEffect(() => {
    if (themes.length === 0) return;

    const savedId = localStorage.getItem("seweb-active-theme-id");
    if (!savedId) return;

    const theme = themes.find((t) => t.id === savedId);
    if (!theme) return;

    applyThemeVariables(theme.css_variables);

    // Sync dark/light class based on palette brightness
    const bgValue = theme.css_variables["--background"] || "";
    const lightness = parseFloat(bgValue.split(" ").pop() || "100");
    if (lightness < 30) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("seweb-theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("seweb-theme", "light");
    }
  }, [themes]);

  return null;
}
